export default function toBeChecked(reason: string): never {
  alert(`Point à vérifer : ${reason}`);
  throw new Error(`To be checked : ${reason}`);
}
